<div class="container">
  <h1>{{ "workorders.list.title" | translate }}</h1>
  <app-workorders-state-filter></app-workorders-state-filter>
  <app-workorders-search class="search"></app-workorders-search>
  <div class="cards" [@.disabled]="animationsAreDisabled">
    <app-workorder-card
      @items
      *ngFor="let workOrder of workOrders$ | async; trackBy: workOrderTrackBy"
      [workOrderId]="workOrder.id"
    ></app-workorder-card>
  </div>
</div>
